<div id="overlay">
  <table class="wrapper">
    <tr>
      <td>
        <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
        <div class="pop-up-container">
          <img
            class="popupimg"
            src="assets/images/common/symbol_bg.webp?t={{ version }}"
          />
          <img
            class="closeiconImg"
            [appImageSprite]="'close'"
            [params]="menu_icons"
            (click)="onCloseClick($event)"
          />

          <div class="text-content symbols-header lang-specific-font-name">
            <span class="symbols-span">
              <img
                class="symbols-icon"
                [appImageSprite]="'key'"
                [params]="menu_icons"
              />
            </span>
            <span class="symbols-text">{{ 'LANG00256' | translate }}</span>
          </div>

          <div class="option-container">
            <div
              *ngFor="let symbols of symbolsArr; let i = index"
              class="symbols-container"
              (click)="onSymbolsClick(symbols)"
            >
              <img
                class="option-img"
                [appImageSprite]="symbols.menuListIconName"
                [params]="menu_icons"
              />
              <div class="text-content gameName lang-specific-font-name">
                <span>{{ symbols.menuListLangCode | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
